module.exports = __webpack_public_path__ + "static/media/All-quick-service.e39e69d6.png";